import React from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';
const getColor = (color, theme) => {
    switch (color) {
        case 'primary': return theme.palette.primary.main;
        case 'secondary': return theme.palette.secondary.main;
        default: return '#005bb7';
    }
};
const useStyles = makeStyles((theme) => ({
    wrapper: {
        position: 'relative',
        marginTop: 14,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    spinner: ({ color }) => ({
        position: 'absolute',
        width: 0,
        height: 0,
        zIndex: 2000000000,
        color: getColor(color, theme),
        animationDuration: '1s'
    })
}));
function Spinner({ color = 'default' }) {
    const classes = useStyles({ color });
    return (React.createElement("div", { className: classes.wrapper },
        React.createElement(CircularProgress, { className: classes.spinner, size: 26 })));
}
export default Spinner;
